import { useMutation } from '@tanstack/react-query'

import { settingsApi } from '../api/settingsApi'

export const useUnsubscribePresubscriberMutation = () =>
  useMutation({
    mutationFn: (email: string) => settingsApi.unsubscribePresubscriber(email),
  })
